import { Component, OnInit ,AfterViewInit } from '@angular/core';
import { HttpService } from '../../../http.service';
import { ShareddataService } from '../../../shareddata.service';

declare var $: any;

import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css']
})
export class OrdersComponent implements OnInit {
  orderType: any = ['Past', 'Upcoming'];
  menuSpin:any;
  orderDetailsObject : any = [];
  responseHeaderData : any = [];
  orderstatus : any = '';
  orderData : any = [];
  res_name : any = '';
  selectedMenuid : any;
  startFill : any =0;
  orderSpin : Number =0;
  loadMoreShow : Number =1;
  loadMoreSpin : Number =0;
  loadReviewSpin : Number =0;
  apiCall : Number =0;
  selctedOrderType : String ='';
  currentPage : any=1;
  ROOT_BASEURL = environment.ROOT_BASEURL;
  BASEURL_SUBMENU_IMGS = environment.BASEURL_SUBMENU_IMGS;
  BASEURL_DEAL_IMGS = environment.BASEURL_DEAL_IMGS;
  constructor(
  private _http: HttpService,
  private sharedService: ShareddataService
  ) { }
   ngOnInit(): void {
	this.apiCall=0;
    this.sharedService.sharedMessage.subscribe((response: any) => { 
		if(response.data){
		this.responseHeaderData=response;
		if(this.responseHeaderData.data.guest_data.token){
			localStorage.setItem('jwt_token',this.responseHeaderData.data.guest_data.token);
			this.res_name=localStorage.getItem('res_name'); 
			if(this.apiCall==0 ){
			}
		}
		}
	});
	this.orderReterive('Past');
	}
	
	orderReterive (type) {
		this.selctedOrderType=type;
		this.currentPage=1;
		this.loadMoreShow=1;
		this.orderData = [];
		if (type==='Past') {
			this.orderSpin=0;
			this.loadMoreSpin=1;
			this.pastOrder(1);
		} if (type==='Upcoming') {
			this.orderSpin=0;
			this.loadMoreSpin=1;
			this.upComingOrder(1);
		}
		setTimeout(function(){ 
			var order_type='ordertype-'+type;
			var els = document.querySelectorAll('.menu-class')
			for (var i = 0; i < els.length; i++) {
				els[i].classList.remove('slected-ordertype')
			}
			
			if(document.getElementById(order_type)){
				(document.getElementById(order_type) as HTMLImageElement).classList.add("slected-ordertype");
			}	
		}, 500);

		
		 
	}
	
	pastOrder (page) {
		var userData=JSON.parse(localStorage.getItem('user_detail'));
		const pastOrders = new FormData();
		pastOrders.append('user_id', userData.id);
		pastOrders.append('page', page);
		
		this._http.postRequest('past_orders.php',pastOrders).subscribe((reponse : any )=>{
			//this.orderData=reponse.data;
			for (var i=0;i<reponse.data.length;i++){
				this.orderData.push(reponse.data[i]);
			}
			if (reponse.data.length==0) {
				this.loadMoreShow=0;
				alert('No more record found');
			}
			var currentpagelocal =this.currentPage;
			this.currentPage=currentpagelocal+1;
			this.orderSpin=0;
			this.loadMoreSpin=0;
			  
		}); 
	}
	upComingOrder (page) {
		var userData=JSON.parse(localStorage.getItem('user_detail'));
		const futureOrders = new FormData();
		futureOrders.append('user_id', userData.id);
		futureOrders.append('page', page);
		
		this._http.postRequest('upcoming_order.php',futureOrders).subscribe((reponse : any )=>{
			//this.orderData=reponse.data;
			for (var i=0;i<reponse.data.length;i++){
				this.orderData.push(reponse.data[i]);
			}
			var currentpagelocal =this.currentPage;
			this.currentPage=currentpagelocal+1;
			this.orderSpin=0;
			this.loadMoreSpin=0;
			if (reponse.data.length==0) {
				this.loadMoreShow=0;
				alert('No more record found');
			}
			  
		}); 
	}
	
  updateUrl(result){
	var submenu_image='submenu_image_'+result;
	(document.getElementById(submenu_image) as HTMLImageElement).src = 'assets/img/prods-sm/5.png';
  }
   orderDetails (order){
	   this.orderDetailsObject = [];
	   if (order.order_status==='0') {
		   this.orderstatus='pending';
	   }if (order.order_status==='1') {
		   this.orderstatus='accept';
	   }if (order.order_status==='2') {
		   this.orderstatus='reject';
	   }if (order.order_status==='3') {
		   this.orderstatus='Picked up';
	   }if (order.order_status==='4') {
		   this.orderstatus='delivered';
	   }if (order.order_status==='5') {
		   this.orderstatus='Assigned to rider,';
	   }if (order.order_status==='6') {
		   this.orderstatus='cancel';
	   }if (order.order_status==='7') {
		   this.orderstatus='Customer reached';
	   }if (order.order_status==='01534') {
		   this.orderstatus='DELIVERY';
	   }if (order.order_status==='04') {
		   this.orderstatus='CARRYOUT';
	   }if (order.order_status==='074') {
		   this.orderstatus='CURBSIDE';
	   }
	   
	   $('#orderDetails').modal('show');
	   this.orderDetailsObject = order;
   }
	loadMore(){
		this.loadMoreSpin=1;
		if (this.selctedOrderType==='Past') {
			this.pastOrder(this.currentPage);
		} if (this.selctedOrderType==='Upcoming') {
			this.upComingOrder(this.currentPage);
		}
	}
	orderReceipt (order) {
		this.orderDetailsObject = order;
		var url = window.location.origin+'/admin/FoodDeliverySystem/iframe/orderinvoiceemail.php?id='+order.order_id;
		$('#recipt-iframe').attr('src', url);
		$('#orderRecipt').modal('show');
	}
	feedbackModal () {
		this.startFill = 0;
		$('.fa-star').removeClass('text-yellow');
		$('.review').val('');
		$('#feedbackModal').modal('show');
	}	
	changeRattingStarts (fill) {
		var starFill = Math.round(fill);
		var starunfil = 5-fill;
		this.startFill = fill;
		var startHtml = '';
		$('.fa-star').removeClass('text-yellow');
		for (var j=1;j<=starFill;j++) {
			$('.start_fill_'+j).addClass('text-yellow');
		}
	}
	orderFeedback () {
		if(this.startFill==0) {
			alert('Please add the ratting first.');
		} else {
		var userData=JSON.parse(localStorage.getItem('user_detail'));
		var startFilllocal = this.startFill;
		const orderFeedback = new FormData();
		orderFeedback.append('order_id', this.orderDetailsObject.order_id);
		orderFeedback.append('user_type', '1');
		orderFeedback.append('user_review', $('.review').val());
		orderFeedback.append('user_rating', startFilllocal);
		orderFeedback.append('tip', '');
		orderFeedback.append('user_id', userData.id);
		this.loadReviewSpin = 1;
		this._http.postRequest('order_feedback.php',orderFeedback).subscribe((reponse : any )=>{
			  this.loadReviewSpin = 0;
			  if(reponse.order) {
				alert(reponse.order);
			  } else {
				  alert('Fail to add Review');
			  }
			$('#feedbackModal').modal('hide');
  
		}); 
		}
	}
	
}
